export default "__VITE_ASSET__7fa6a699__"